import { map, mergeMap } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { STORAGE_KEYS } from '../../declarations/storage-keys.enum';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { concatLatestFrom } from '@ngrx/operators';
import { Store } from '@ngrx/store';
import { from, of, switchMap } from 'rxjs';
import { Preferences } from '@capacitor/preferences';
import {
  LOAD_CURRENT_EVENTS_FILTERS,
  SET_CURRENT_EVENTS_FILTERS
} from './events.actions';
import {
  ArticleEventFilter,
  INITIAL_EVENT_FILTERS
} from '../../declarations/article.interface';
import { getCurrentEventsFilters } from './events.selectors';
import {
  SET_CURRENT_TENANT,
  SetCurrentTenantAction
} from '../tenant-state/tenant.actions';

@Injectable()
export class EventsEffects {
  initializeEventsAfterTenant$ = createEffect(() =>
    this.actions$.pipe(
      ofType(SET_CURRENT_TENANT),
      concatLatestFrom(() => this.store.select(getCurrentEventsFilters)),
      map(
        ([{ payload }, currentFilters]: [
          SetCurrentTenantAction,
          ArticleEventFilter
        ]) => ({
          type: SET_CURRENT_EVENTS_FILTERS,
          payload: {
            ...INITIAL_EVENT_FILTERS,
            origin: payload?.tenant_setting?.filter_by_location_by_default
              ? 'my_settlement'
              : 'all',
            ...currentFilters
          }
        })
      )
    )
  );

  loadCurrentEventsFilters$ = createEffect(() =>
    this.actions$.pipe(
      ofType(LOAD_CURRENT_EVENTS_FILTERS),
      mergeMap(() =>
        from(
          Preferences.get({ key: STORAGE_KEYS.CURRENT_EVENTS_FILTERS })
        ).pipe(
          map(v => JSON.parse(v.value)),
          map(t => ({
            type: SET_CURRENT_EVENTS_FILTERS,
            payload: t ?? INITIAL_EVENT_FILTERS
          }))
        )
      )
    )
  );

  saveCurrentEventsFiltersToStorage$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(SET_CURRENT_EVENTS_FILTERS),
        concatLatestFrom(() => this.store.select(getCurrentEventsFilters)),
        switchMap(([, f]) => {
          if (f !== null) {
            return from(
              Preferences.set({
                key: STORAGE_KEYS.CURRENT_EVENTS_FILTERS,
                // A fresh app start always shows upcoming events, so 'past' is never stored.
                value: JSON.stringify(
                  f.period === 'past'
                    ? { ...f, period: INITIAL_EVENT_FILTERS.period }
                    : f
                )
              })
            );
          } else {
            return of(f);
          }
        })
      ),
    { dispatch: false }
  );

  constructor(
    private actions$: Actions,
    private store: Store
  ) {}
}
